/***
 *Â @FileName:
 *Â @Author: manyao.zhu
 *Â @Date: 2020-06-11 17:48:36
 */
import { Component, OnInit } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';

@Component({
  selector: 'dt-feishu-user',
  templateUrl: './feishu-user.component.html',
  styleUrls: ['./feishu-user.component.scss'],
})
export class FeishuUserComponent implements OnInit {
  showDialog = false;
  user: any;

  constructor(private settingSrv: SettingsService) {
    this.user = this.settingSrv.user;
  }

  ngOnInit() {}

  showDialogs() {
    this.showDialog = true;
  }

  closeDialogs() {
    this.showDialog = false;
  }
}
